import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

/**
 * SaaS subscription billing for the logged-in merchant (slice 1: card vaulting). Goes through CagistaServices
 * `/api/site/billing/**` (ADMIN, tenant-isolated). The recurrence token is stored encrypted server-side and
 * NEVER reaches the browser. Config-gated server-side: startVault() returns { configured:false } when the
 * CAGISTA Dintero account isn't set up.
 */
class SubscriptionService {
    startVault() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/site/billing/startVault', { merchant: user.merchant }, { headers: authHeader() });
    }

    getStatus() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/site/billing/status?merchant=' + user.merchant, { headers: authHeader() });
    }

    confirm(transactionId) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/site/billing/confirm', { merchant: user.merchant, transactionId: transactionId }, { headers: authHeader() });
    }

    cancel() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/site/billing/cancel', { merchant: user.merchant }, { headers: authHeader() });
    }

    resume() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.post('/api/site/billing/resume', { merchant: user.merchant }, { headers: authHeader() });
    }

    // CAGISTA's receipts for the licence: under /api/report/**, not /api/site/**, because the accountant reads them too
    // (ACCOUNTANT, ADMIN, SUPER_ADMIN; not EMPLOYEE).

    getReceipts() {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/report/getSubscriptionReceipts?merchant=' + encodeURIComponent(user.merchant), { headers: authHeader() });
    }

    /** One receipt's PDF: { fileName, pdf } with the PDF in base64. */
    getReceiptPdf(id) {
        let user = JSON.parse(localStorage.getItem('user'));
        return axios.get('/api/report/getSubscriptionReceiptPdf?merchant=' + encodeURIComponent(user.merchant)
            + '&id=' + encodeURIComponent(id), { headers: authHeader() });
    }
}

export default new SubscriptionService();
